import { type ReactNode } from 'react'
import styles from './JobsViewerHeader.module.css'

export interface JobsViewerHeaderProps {
  children: ReactNode
}

export function JobsViewerHeader({ children }: JobsViewerHeaderProps) {
  return <div className={styles.jobsViewerHeader}>{children}</div>
}
